<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('faq.title') }}</h3>
            <div class="boxInner">
                <dl class="accordion">
                    <dt class="box1"
                        @click="handleClickAccordion($event)"
                        v-bind:class="{active: activeElement === 'box1'}">
                        {{ $t('faq.box1.title') }}
                    </dt>
                    <transition name="animateAccordion">
                        <dd v-if="activeElement === 'box1'">
                            <div class="question">
                                <a href="#" v-scroll-to="'#q01'">{{ $t('faq.box1.q1.question') }}</a>
                            </div>
                            <div class="question">
                                <a href="#" v-scroll-to="'#q02'">{{ $t('faq.box1.q2.question') }}</a>
                            </div>
                            <div class="question">
                                <a href="#" v-scroll-to="'#q03'">{{ $t('faq.box1.q3.question') }}</a>
                            </div>
                            <div class="question">
                                <a href="#" v-scroll-to="'#q04'">{{ $t('faq.box1.q4.question') }}</a>
                            </div>
                        </dd>
                    </transition>
                </dl>

                <dl class="accordion">
                    <dt class="box2"
                        @click="handleClickAccordion($event)"
                        v-bind:class="{active: activeElement === 'box2'}">
                        {{ $t('faq.box2.title') }}
                    </dt>
                    <transition name="animateAccordion">
                        <dd v-if="activeElement === 'box2'">
                            <div class="question">
                                <a href="#" v-scroll-to="'#q11'">{{ $t('faq.box2.q1.question') }}</a>
                            </div>
                            <div class="question">
                                <a href="#" v-scroll-to="'#q12'">{{ $t('faq.box2.q2.question') }}</a>
                            </div>
                        </dd>
                    </transition>
                </dl>

                <dl class="accordion">
                    <dt class="box3"
                        @click="handleClickAccordion($event)"
                        v-bind:class="{active: activeElement === 'box3'}">
                        {{ $t('faq.box3.title') }}
                    </dt>
                    <transition name="animateAccordion">
                        <dd v-if="activeElement === 'box3'">
                            <div class="question">
                                <a href="#" v-scroll-to="'#q21'">{{ $t('faq.box3.q1.question') }}</a>
                            </div>
                        </dd>
                    </transition>
                </dl>

                <dl class="accordion">
                    <dt class="box4"
                        @click="handleClickAccordion($event)"
                        v-bind:class="{active: activeElement === 'box4'}">
                        {{ $t('faq.box4.title') }}
                    </dt>
                    <transition name="animateAccordion">
                        <dd v-if="activeElement === 'box4'">
                            <div class="question">
                                <a href="#" v-scroll-to="'#q31'">{{ $t('faq.box4.q1.question') }}</a>
                            </div>
                        </dd>
                    </transition>
                </dl>

                <dl class="accordion">
                    <dt class="box5"
                        @click="handleClickAccordion($event)"
                        v-bind:class="{active: activeElement === 'box5'}">
                        {{ $t('faq.box5.title') }}
                    </dt>
                    <transition name="animateAccordion">
                        <dd v-if="activeElement === 'box5'">
                            <div class="question">
                                <a href="#" v-scroll-to="'#q41'">{{ $t('faq.box5.q1.question') }}</a>
                            </div>
                            <div class="question">
                                <a href="#" v-scroll-to="'#q42'">{{ $t('faq.box5.q2.question') }}</a>
                            </div>
                        </dd>
                    </transition>
                </dl>

                <dl class="accordion">
                    <dt class="box6"
                        @click="handleClickAccordion($event)"
                        v-bind:class="{active: activeElement === 'box6'}">
                        {{ $t('faq.box6.title') }}
                    </dt>
                    <transition name="animateAccordion">
                        <dd v-if="activeElement === 'box6'">
                            <div class="question">
                                <a href="#" v-scroll-to="'#q51'">{{ $t('faq.box6.q1.question') }}</a>
                            </div>
                        </dd>
                    </transition>
                </dl>
                <div class="answerWrapper">
                    <div class="answer">
                        <div class="title">
                            {{ $t('faq.box1.title') }}
                            <div class="scrollTop" @click="handleToTopPage()">
                                {{ $t('faq.toTopBtn') }}
                            </div>
                        </div>
                        <div class="block" id="q01">
                            <div class="q">{{ $t('faq.box1.q1.question') }}</div>
                            <div class="a" v-html="$t('faq.box1.q1.answer')"></div>
                        </div>
                        <div class="block" id="q02">
                            <div class="q">{{ $t('faq.box1.q2.question') }}</div>
                            <div class="a" v-html="$t('faq.box1.q2.answer')"></div>
                        </div>
                        <div class="block" id="q03">
                            <div class="q">{{ $t('faq.box1.q3.question') }}</div>
                            <div class="a" v-html="$t('faq.box1.q3.answer')"></div>
                        </div>
                        <div class="block" id="q04">
                            <div class="q">{{ $t('faq.box1.q4.question') }}</div>
                            <div class="a" v-html="$t('faq.box1.q4.answer')"></div>
                        </div>
                    </div>

                    <div class="answer">
                        <div class="title">
                            {{ $t('faq.box2.title') }}
                            <div class="scrollTop" @click="handleToTopPage()">
                                {{ $t('faq.toTopBtn') }}
                            </div>
                        </div>
                        <div class="block" id="q11">
                            <div class="q">{{ $t('faq.box2.q1.question') }}</div>
                            <div class="a" v-html="$t('faq.box2.q1.answer')"></div>
                        </div>
                        <div class="block" id="q12">
                            <div class="q">{{ $t('faq.box2.q2.question') }}</div>
                            <div class="a" v-html="$t('faq.box2.q2.answer')"></div>
                        </div>
                    </div>

                    <div class="answer">
                        <div class="title">
                            {{ $t('faq.box3.title') }}
                            <div class="scrollTop" @click="handleToTopPage()">
                                {{ $t('faq.toTopBtn') }}
                            </div>
                        </div>
                        <div class="block" id="q21">
                            <div class="q">{{ $t('faq.box3.q1.question') }}</div>
                            <div class="a" v-html="$t('faq.box3.q1.answer')"></div>
                        </div>
                    </div>

                    <div class="answer">
                        <div class="title">
                            {{ $t('faq.box4.title') }}
                            <div class="scrollTop" @click="handleToTopPage()">
                                {{ $t('faq.toTopBtn') }}
                            </div>
                        </div>
                        <div class="block" id="q31">
                            <div class="q">{{ $t('faq.box4.q1.question') }}</div>
                            <div class="a" v-html="$t('faq.box4.q1.answer')"></div>
                        </div>
                    </div>

                    <div class="answer">
                        <div class="title">
                            {{ $t('faq.box5.title') }}
                            <div class="scrollTop" @click="handleToTopPage()">
                                {{ $t('faq.toTopBtn') }}
                            </div>
                        </div>
                        <div class="block" id="q41">
                            <div class="q">{{ $t('faq.box5.q1.question') }}</div>
                            <div class="a" v-html="$t('faq.box5.q1.answer')"></div>
                        </div>
                        <div class="block" id="q42">
                            <div class="q" >{{ $t('faq.box5.q2.question') }}</div>
                            <div class="a" v-html="$t('faq.box5.q2.answer')"></div>
                        </div>
                    </div>

                    <div class="answer">
                        <div class="title">
                            {{ $t('faq.box6.title') }}
                            <div class="scrollTop" @click="handleToTopPage()">
                                {{ $t('faq.toTopBtn') }}
                            </div>
                        </div>
                        <div class="block" id="q51">
                            <div class="q">{{ $t('faq.box6.q1.question') }}</div>
                            <div class="a" v-html="$t('faq.box6.q1.answer')"></div>
                            <div class="text-center mt-2 a">
                                <div class="version_info">
                                    <div>{{ $t('faq.box6.q1.pc.title') }}</div>
                                    <table class="faq_pc">
                                        <tbody>
                                            <tr>
                                                <th></th>
                                                <th>{{ $t('faq.box6.q1.pc.tr1.th1') }}</th>
                                                <th>{{ $t('faq.box6.q1.pc.tr1.th2') }}</th>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('faq.box6.q1.pc.tr2.td1') }}</td>
                                                <td>{{ $t('faq.box6.q1.pc.tr2.td2') }}</td>
                                                <td>{{ $t('faq.box6.q1.pc.tr2.td3') }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('faq.box6.q1.pc.tr3.td1') }}</td>
                                                <td>
                                                    {{ $t('faq.box6.q1.pc.tr3.td2.1') }}<br>
                                                    {{ $t('faq.box6.q1.pc.tr3.td2.2') }}<br>
                                                    {{ $t('faq.box6.q1.pc.tr3.td2.3') }}
                                                </td>
                                                <td>
                                                    {{ $t('faq.box6.q1.pc.tr3.td3.1') }}<br>
                                                    {{ $t('faq.box6.q1.pc.tr3.td3.2') }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div>{{ $t('faq.box6.q1.sp.title') }}</div>
                                    <table class="faq_sp">
                                        <tbody>
                                            <tr>
                                                <th></th>
                                                <th>{{ $t('faq.box6.q1.sp.tr1.th1') }}</th>
                                                <th>{{ $t('faq.box6.q1.sp.tr1.th2') }}</th>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('faq.box6.q1.sp.tr2.td1') }}</td>
                                                <td>
                                                    {{ $t('faq.box6.q1.sp.tr2.td2.1') }} <br>
                                                    {{ $t('faq.box6.q1.sp.tr2.td2.2') }} <br>
                                                    {{ $t('faq.box6.q1.sp.tr2.td2.3') }} <br>
                                                    {{ $t('faq.box6.q1.sp.tr2.td2.4') }} <br>
                                                    {{ $t('faq.box6.q1.sp.tr2.td2.5') }} 
                                                </td>
                                                <td>
                                                    {{ $t('faq.box6.q1.sp.tr2.td3.1') }} <br>
                                                    {{ $t('faq.box6.q1.sp.tr2.td3.2') }} <br>
                                                    {{ $t('faq.box6.q1.sp.tr2.td3.3') }} <br>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('faq.box6.q1.sp.tr3.td1') }}</td>
                                                <td>
                                                    {{ $t('faq.box6.q1.sp.tr3.td2') }}
                                                </td>
                                                <td>
                                                    {{ $t('faq.box6.q1.sp.tr3.td3.1') }}<br>
                                                    {{ $t('faq.box6.q1.sp.tr3.td3.2') }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import languageService from '../../services/LanguageService';

export default {
    name: 'faq',

    data() {
            return {
                activeElement: null,
                lang: 'en',
            }
        },

    async created() {
        this.lang = languageService.getCurrentLanguageShortCode();
    },

    components: {
    },
        
    methods: {
        handleToTopPage() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        handleClickAccordion(event) {
            if (this.activeElement !== event.target.className) {
                this.activeElement = event.target.className;
            } else {
                this.activeElement = null;
            }
        },
    },

    mounted() {
    },

    watch: {                                                                          
        '$i18n.locale': function(locale) {
            this.lang = languageService.getCurrentLanguageShortCode();
        }
    }
}
</script>

<style>
.animateAccordion-enter-active,
.animateAccordion-leave-active {
    transition: all 0.2s;
    max-height: 230px;
}
    .animateAccordion-enter,
    .animateAccordion-leave-to
    {
        opacity: 0;
        max-height: 0px;
    }


/*対応バージョン一覧表示用スタイル */
/*二つのテーブルを囲むラッパー*/
.version_info {
    width: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
/*タイトル部分*/
.version_info>div{
    width:100%;
    display:flex;
    justify-content: flex-start;
    background-color: #882cec;
    color: white;
    font-weight: bold;
    padding: 1% 0 1% 1%;
}
/*テーブルの中身*/
.version_info table{
    width: 98%;
    justify-content: center;
}
.version_info tr {
    justify-content: center;
}
.faq_pc tbody td,
.faq_sp tbody td {
    vertical-align: middle;
    padding: 2% 0;
    color: black;
}
.version_info th {
    color: #882cec;
    padding: 2% 0;
}
.version_info tr:not(:last-child) {
    border-bottom: solid 1px #882cec;
}
.faq_pc{
    margin-bottom: 5%;
}
@media screen and (max-width: 320px){
    .version_info{
        font-size: 7px;
    }
}
</style>
